
import React , {useState} from 'react'
import Navbar from './Navbar'
import Platform from './Platform';
import Impacts from './Impacts';
import Impactgrid from './Impactgrid';
import Studydestinations from './Studydestination';
import Footer from './Footer';
import MarqueeComponent from './Marquee';
import Tours from './Tours';
import WhatsAppSupport from './WhatsappSupport';
import ScrollToTop from './ScrollToTop';
import { Link } from 'react-router-dom';
import InfoSection from './InfoSection';
import ItineraryDialog from './ItineraryDialog';
import { MegaMenu } from './MegaMenu';


const Home = () => {
  

  
  const data = [
    { day: "Day 1", description: "Flight from assigned Airport. Upon arrival, check in to the hotel.", image: "/images/China.png" },
    { day: "Day 2", description: "Guided tour visits to Tiananmen Square, Forbidden City, Confucius Temple, The Imperial College, and Hutong.", iimage: "/images/China.png" },
    { day: "Day 3", description: "Guided tour visits to Juyongguan Great Wall, an 18-kilometer-long wall, and The Summer Palace, an imperial garden from the Qing Dynasty.", iimage: "/images/China.png" },
    { day: "Day 4", description: "Travel from Beijing to Shanghai by high-speed train.", iimage: "/images/China.png" },
    { day: "Day 5", description: "Visit Volkswagen New Energy Factory, including a video of the factory, Production Exhibition Hall, and Workshop. Also visit The Bund and Nanjing Road.", image: "/images/China.png" },
    { day: "Day 6", description: "Full day activity at Suzhou after a 2-hour drive. Visit a local school, Lingering Garden, and No.1 Silk Factory.", image: "/images/China.png"},
    { day: "Day 7", description: "Guided tour visits to Oriental Pearl TV Tower (263m), Xintiandi, Tianzifang Old Quarters, and Former French Concession.", image: "/images/China.png" },
    { day: "Day 8", description: "Departure. Arrive home to cherish memories.", image: "/images/China.png" }
  ];

  const images = [
    '/images/im1.png',
    '/images/im2.png',
    '/images/im3.png',
    '/images/im4.png',
    '/images/im5.png',
    '/images/im6.png',
    '/images/im7.png',
    '/images/im8.png',
    '/images/im10.png',
    '/images/im11.png',
    '/images/im12.png',
    '/images/im13.png',
    '/images/im14.png',
    '/images/im15.png',
    '/images/im16.png',
    '/images/im17.png',
    '/images/im18.png',
    '/images/im19.png',
    '/images/im20.png',
    '/images/im21.png',
    '/images/im22.png',
    '/images/im23.png',
    '/images/im24.png',
    '/images/im25.png',
    '/images/im26.png',
    '/images/im27.png',
    '/images/im28.png',
    '/images/im29.png',
    '/images/im30.png',
    '/images/im31.png',
    '/images/im32.png',
    '/images/im33.png',
    '/images/im34.png',
    '/images/im35.png',
    '/images/im36.png',
    '/images/im37.png',
    '/images/im38.png',
    '/images/im39.png',
  ];
  const images1 = [
    '1.png',
    '2.png',
    '3.png',
    '4.png',
    '5.png',
    '6.png',
    '7.png',
    '8.png',
    '10.png',
    '11.png',
    '12.png',
    '13.png',
    '14.png',
    '15.png',
    '16.png',
    '17.png',
    '18.png',
    '19.png',
    '20.png',
    '21.png',
    '22.png',
    '23.png',
    '24.png',
    '25.png',
    '26.png',

  ];
  return (
    <div className="bg-white min-h-screen">
      {/* Header Section */}

      {/* <Navbar /> */}
      
     <MegaMenu background="bg-transparent"/>
      {/* Main Section */}
      <div className="relative h-[100vh]">

        {/* Background Video */}
        <div className="absolute inset-0 h-full">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover"
          >
            <source src="new.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        {/* Overlay Content */}
        <div className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center px-6 md:px-8 lg:px-12 bg-black bg-opacity-60 space-y-5">

          <h1 className="text-white text-2xl lg:text-5xl notoh w-full sm:w-3/4 font-semibold">
            OVERSEAS EDUCATION & EDUCATIONAL TOURS
          </h1>


          <p className=' text-white hidden sm:block'>Unlock global opportunities with our overseas education programs and educational tours. Experience diverse cultures, <br /> gain valuable insights,  and enhance your academic and personal growth through transformative international experiences.</p>
          <h5 className=' text-white text-xs lg:hidden'>Discover global educational opportunities and enriching tours that will enhance your learning and cultural experiences abroad.</h5>

          <div className="flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-4">
            <Link to="/programs" className="w-full sm:w-auto">
              <button className="bg-blue-400 text-white px-4 sm:px-6 py-[10px] rounded-full font-medium shadow-lg hover:bg-blue-400 hover:text-white transition-all sm:w-60 md:w-72 lg:w-[330px] poppins text-xs sm:text-sm md:text-base">
                I want to study abroad
              </button>
            </Link>
            <Link to="/destination" className="w-full sm:w-auto">
              <button className="bg-white text-blue-900 px-4 sm:px-6 py-[10px] rounded-full font-medium shadow-lg hover:bg-blue-400 hover:text-white transition-all sm:w-60 md:w-72 lg:w-[330px] poppins text-xs sm:text-sm md:text-base">
              Educational tours around the world
              </button>
            </Link>
            <Link to="/ai-certification" className="w-full sm:w-auto">
              <button className="bg-green-500 text-white px-4 sm:px-6 py-[10px] rounded-full font-medium shadow-lg hover:bg-blue-400 hover:text-white transition-all sm:w-60 md:w-72 lg:w-[330px] poppins text-xs sm:text-sm md:text-base">
              I want to enroll for AI online course
              </button>
            </Link>
          </div>
        </div>
      </div>




      {/* Other Sections */}
      <Platform />
      <InfoSection />
      <Tours heading="Top-Picked Educational Tours" />
      <Impacts />
      <Impactgrid />
      <div className="overflow-hidden">
      <h1 className="text-2xl md:text-2xl lg:text-4xl notoh font-bold text-center pb-2 lg:pb-5 pt-16 text-gray-800">
        Our Applicants Have Been Admitted To
      </h1>
      <MarqueeComponent images={images} />
      </div>

      <div className="overflow-hidden">
      <h1 className="text-2xl md:text-2xl lg:text-4xl notoh font-bold text-center pb-2 lg:pb-5 pt-16 text-gray-800">
        Our Clientele
      </h1>
      <MarqueeComponent images={images1} />
      </div>
      <Studydestinations />
      {/* <div className="p-6">
      <button
        onClick={handleOpenDialog}
        className="px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 font-semibold"
      >
        Open Itinerary
      </button>
      <ItineraryDialog isOpen={isDialogOpen} onClose={handleCloseDialog} data={data} />
    </div> */}
      {/* <WhatsAppSupport/> */}
      <ScrollToTop />
      <Footer />
      <ItineraryDialog/>
    </div>
  );
}

export default Home;
